import { Subject } from 'rxjs';
import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';

import { UnRx } from '@pebula/utils';

import { DialogConfigType } from './base-dialog-config-type';

@Component({
  selector: 'sg-base-dialog-trigger',
  templateUrl: 'base-dialog.component.html',
  styleUrls: ['./base-dialog.component.scss'],
  standalone: false,
})
@UnRx()
export class SgDialogComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input() dialogConfigData: DialogConfigType;
  @Input() closeDialogFromOutside: Subject<boolean>;

  @Output() closeDialog = new EventEmitter<boolean>();

  @ViewChild('template', { static: true }) template: TemplateRef<any>;

  isEmptyDialog = true;
  dialogRef: MatDialogRef<any>;

  constructor(private dialog: MatDialog) {}

  ngOnInit(): void {
    this.closeDialogFromOutside?.pipe(UnRx(this)).subscribe((event) => this._dialogClose());
  }

  ngAfterViewInit(): void {
    const { minHeight, minWidth, maxHeight, maxWidth } = this.dialogConfigData;
    this.isEmptyDialog = this.dialogConfigData.isEmptyDialog;

    const panelClasses = [this.dialogConfigData.panelClass];
    if (this.dialogConfigData.noPadding === true) {
      panelClasses.push('no-padding-dialog');
    }

    this.dialogRef = this.dialog.open(this.template, {
      minHeight,
      minWidth,
      maxHeight,
      maxWidth,
      autoFocus: this.dialogConfigData.autoFocus,
      panelClass: panelClasses,
    });

    this.dialogRef
      .afterClosed()
      .pipe(UnRx(this))
      .subscribe(() => this.closeDialog.emit());
  }

  ngOnDestroy(): void {
    if (this.dialogRef) this._dialogClose();
  }

  private _dialogClose(): void {
    const dialogRef = this.dialogRef;
    this.dialogRef = null;
    dialogRef.close();
  }
}
